// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styles from './App.module.css';

// ... (tous vos imports de composants de section restent les mêmes)
import Navbar from './components/Navbar/Navbar'; 
import Hero from './sections/Hero/Hero';
import MenuFormulas from './sections/MenuFormulas/MenuFormulas'; 
import PokeBowls from './sections/PokeBowls/PokeBowls';
import Sushis from './sections/Sushis/Sushis';
import AccompanimentsAndStarters from './sections/AccompanimentsAndStarters/AccompanimentsAndStarters';
import OurPlatters from './sections/OurPlatters/OurPlatters'; 
import MainDishes from './sections/MainDishes/MainDishes';
import Specialties from './sections/Specialties/Specialties';
import SteamedDishes from './sections/SteamedDishes/SteamedDishes';
import Desserts from './sections/Desserts/Desserts';
import Drinks from './sections/Drinks/Drinks';
import Contact from './sections/Contact/Contact';
import Footer from './components/Footer/Footer';
import OrderPhone from './sections/OrderPhone/OrderPhone';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';

// IMPORTS DE VOS PAGES LÉGALES
import LegalMentions from './pages/LegalMentions/LegalMentions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';

// <-- CHANGEMENT ICI : Importer le nouveau composant
import ScrollToSection from './components/ScrollToSection'; 

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  // ... (tout votre code useState, useEffect, etc. reste identique)
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  
  const [favorites, setFavorites] = useState(() => {
    const savedFavorites = localStorage.getItem('lepoke-favorites');
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });

  useEffect(() => {
    localStorage.setItem('lepoke-favorites', JSON.stringify(favorites));
  }, [favorites]);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
    if (!isNavOpen && isFavoritesOpen) setIsFavoritesOpen(false); 
  };

  const toggleFavorites = () => {
    setIsFavoritesOpen(!isFavoritesOpen);
    if (!isFavoritesOpen && isNavOpen) setIsNavOpen(false); 
  };

  const closeMenus = () => {
    setIsNavOpen(false);
    setIsFavoritesOpen(false);
  };

  const addFavorite = (item) => {
    if (!favorites.some(favItem => favItem.id === item.id)) {
      setFavorites(prevFavorites => [...prevFavorites, item]);
    }
  };

  const removeFavorite = (itemId) => {
    setFavorites(prevFavorites => prevFavorites.filter(favItem => favItem.id !== itemId));
  };

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`Installation : ${outcome}`);
      if (outcome === 'accepted') {
        setShowInstallButton(false);
        setDeferredPrompt(null);
      }
    }
  };

  return (
    <Router>
      {/* <-- CHANGEMENT ICI : Ajouter le composant qui gère le scroll */}
      <ScrollToSection />
      <div className={styles.app}>
        <Navbar 
          isNavOpen={isNavOpen} 
          toggleNav={toggleNav} 
          isFavoritesOpen={isFavoritesOpen} 
          toggleFavorites={toggleFavorites}
          closeMenus={closeMenus}
          favorites={favorites}
          removeFavorite={removeFavorite}
        />

        <Routes>
          {/* <-- CHANGEMENT ICI : La route "attrape-tout"
            Cette route va maintenant correspondre à "/", "/poke-bowls", "/sushis", etc.
            et affichera toujours la page principale complète.
          */}
          <Route path="/*" element={ 
            <React.Fragment> 
              <main>
                <Hero id="accueil" />
                <MenuFormulas id="menu-formules" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <PokeBowls id="poke-bowls" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <Sushis id="sushis" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <AccompanimentsAndStarters id="accompagnements-entrees" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <OurPlatters id="nos-plateaux" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <MainDishes id="plats" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <Specialties id="specialites" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <SteamedDishes id="vapeurs" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <Desserts id="desserts" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <Drinks id="boissons" favorites={favorites} addFavorite={addFavorite} removeFavorite={removeFavorite} />
                <OrderPhone id="commander-par-telephone" /> 
                <Contact id="contact" />
              </main>
            </React.Fragment>
          } />

          {/* Ces routes fonctionnent toujours comme avant */}
          <Route path="/mentions-legales" element={<LegalMentions />} />
          <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
        </Routes>

        <Footer showInstallButton={showInstallButton} onInstallClick={handleInstallClick} />
        <FloatingButtons />
      </div>
    </Router>
  );
}

export default App;